import { Title } from '../../../../../components/Title';
import claimPayIcon from '../../../../../assets/claim-pay-icon.svg';

export const InfoTitle = () => <Title title='Claim Payment'>
  <img alt='claimpay' src={claimPayIcon} />
</Title>;